export const SPIKE_WINDOW_MS = 60_000;

export const SPIKE_MAX_PER_KEY = 5;
